import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import { getDateCustomFields } from '../../../app/utils';
import IcHelpCircle from '../../../assets/images/svg/ic-help-circle.svg';
import { setNodeById, setSelectedNode } from '../../../features/mainSlice';
import Dropdown from '../../shared/Dropdown';
import TextField from '../../shared/TextField';
import Tooltip from '../../shared/Tooltip';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: 12,
      display: 'flex',
      alignItems: 'center',
      '& > img': {
        marginLeft: 4,
      },
    },
    days: {
      marginTop: 12,
      borderRadius: 24,
      backgroundColor: '#F9F9F9',
      padding: '12px 16px',
      color: color.$13,
      fontSize: '15px',
      lineHeight: '15px',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      '& > div': {
        whiteSpace: 'nowrap',
      },
    },
  },
  {
    name: 'CustomFieldDate',
  },
);

const CustomFieldDate = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode, isErrorNodeIds } = useSelector(state => state.ma);
  const { features } = useSelector(state => state.organization);
  const { data } = selectedNode || {};
  const { conditions } = data || {};
  const { fieldId, daysBefore } = conditions || {};
  const isError = !!~isErrorNodeIds.indexOf(selectedNode?.id);

  const onChange = value => {
    const newNode = {
      ...selectedNode,
      data: {
        ...data,
        conditions: { ...conditions, ...value },
      },
    };

    dispatch(setSelectedNode(newNode));
    dispatch(setNodeById(newNode));
  };

  const menuItems = getDateCustomFields(features).map(f => ({
    text: f.name,
    value: f.id,
  }));

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        {t(`trigger.customFieldDate`)}
        <Tooltip light placement="top" title={t('customFieldDateTooltip')}>
          <img src={IcHelpCircle} alt="alert" />
        </Tooltip>
      </div>
      <Dropdown
        menuItems={menuItems}
        value={fieldId}
        onChange={value => onChange({ fieldId: value })}
      />
      <div className={classes.days}>
        <div>{t('customFieldDate.daysBefore1')}</div>
        <TextField
          type="text"
          isValid
          value={daysBefore || ''}
          onChange={event => {
            const { value } = event.target;
            const parsedValue = parseInt(value, 10);
            if (value === '') {
              onChange({ daysBefore: undefined });
            } else if (!Number.isNaN(parsedValue) && parsedValue > 0) {
              onChange({ daysBefore: parsedValue });
            }
          }}
          isError={isError && !(daysBefore > 0)}
        />
        <div>{t('customFieldDate.daysBefore2')}</div>
      </div>
    </div>
  );
};

export default CustomFieldDate;
